/**
 * 전역 '유료 플랜 전용' 안내 팝업 상태.
 * 무료 사용자가 잠긴 동작(편집포맷 다운로드 등)을 누르면 토스트 대신 모달로 명확히 안내.
 */
import { create } from 'zustand'

interface PaidModalState {
  isOpen: boolean
  title: string
  message: string
  open: (message?: string, title?: string) => void
  close: () => void
}

export const usePaidModalStore = create<PaidModalState>((set) => ({
  isOpen: false,
  title: '유료 플랜 전용 기능',
  message: '',
  open: (message, title) =>
    set({
      isOpen: true,
      message: message || '이 기능은 Starter 플랜부터 이용할 수 있습니다.',
      title: title || '유료 플랜 전용 기능',
    }),
  close: () => set({ isOpen: false }),
}))
